import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/layout.tsx");
